"use client";

import { ReactNode, useEffect, useMemo } from "react";

import { initAmplitude } from "@saas/core/amplitude";
import { queryClient } from "@saas/core/react-query/query-client/query-client";
import { FlagKeys } from "@saas/flags/utils/@type/flag-keys/flag-keys";
import { Snackbar } from "@saas/layout/ui/snackbar/snackbar";
import { AlertProvider } from "@saas/shared/feature/alert/alert";

import { QueryClientProvider } from "@tanstack/react-query";
import { FlagsProvider } from "flagged";

export interface IProvidersProps {
  children: ReactNode;
  flags?: Record<FlagKeys, boolean>;
}

export const Providers = ({ children, flags }: IProvidersProps) => {
  const memoizedQueryClient = useMemo(() => queryClient, []);

  useEffect(() => {
    // initialize amplitude only in browser
    if (typeof window !== "undefined") initAmplitude();
  }, []);

  return (
    <QueryClientProvider client={memoizedQueryClient}>
      <FlagsProvider features={flags}>
        <AlertProvider>
          <Snackbar />
          {children}
        </AlertProvider>
      </FlagsProvider>
    </QueryClientProvider>
  );
};
